import { IThreeVariantXP } from '@faire/web-api--source/indigofair/settings/IThreeVariantXP';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * Experiment for shifting metadata to right-side of PDP page
 */
export const PRODUCT_PAGE_METADATA_SHIFT_V2_250521 =
  'PRODUCT_PAGE_METADATA_SHIFT_V2_250521' as SettingConst<
    'PRODUCT_PAGE_METADATA_SHIFT_V2_250521',
    keyof typeof IThreeVariantXP.Bucket,
    'RETAILER'
  >;
